import React from "react"
import Modal from "aldoo-ra/Modal"
import Button from "aldoo-ra/Button"
import { navigate } from "vike/client/router"

const PriceDialog = ({ isOpen, onClose, onContinue, texts }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      variant="centered"
      className="md:max-w-md"
      closeOnEscape={true}
      title={texts?.priceTitle}
    >
      <div className="flex flex-col gap-5">
        <p className="text-sm text-text_secondary mt-0 mb-2">
          {texts?.priceSubtitle}
        </p>

        <div className="flex flex-col gap-3">
          <Button variant="primary" onClick={() => navigate("/pricing")} className="w-full">
            {texts?.seePricing}
          </Button>

          <Button variant="secondary" onClick={onContinue} className="w-full">
            {texts?.continueCancel}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default PriceDialog
